import { render } from "./EditLogoOrg.vue?vue&type=template&id=1fd98e6a&scoped=true"
import script from "./EditLogoOrg.vue?vue&type=script&lang=js"
export * from "./EditLogoOrg.vue?vue&type=script&lang=js"

import "./EditLogoOrg.vue?vue&type=style&index=0&id=1fd98e6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd98e6a"]])

export default __exports__